import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {InsurableObjectService} from "../api/insurable-object.service";
import {
  ContractInsurableObjectImageType,
  ContractInsurableObjectType,
  ContractsRuntimeObjectDto
} from "../types/contracts.types";
import {ImageDto} from "../../../core/interfaces/core.types";
import {UserApiService} from "../../user/api/user-api.service";


@Directive({
  selector: '[insurableObjectImage]',
  standalone: true
})
export class ObjectTypeImageDirective implements OnInit, OnChanges {

  @Input() insurableObject?: ContractsRuntimeObjectDto;
  initialized: boolean = false;

  constructor(
    private el: ElementRef,
    protected insurableObjectService: InsurableObjectService,
    protected userService: UserApiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes['insurableObject']) {
      this.ngOnInit(); // Or call an extracted updateImage() method
    }
  }

  ngOnInit(): void {

    this.initialized = true;

    if (this.insurableObject?.objectType == ContractInsurableObjectType.OBJECT && this.insurableObject?.imageType == ContractInsurableObjectImageType.URL) {

      this.applyImage(this.insurableObject.imageUrl);

    } else if (this.insurableObject?.objectType == ContractInsurableObjectType.OBJECT &&
      this.insurableObject?.imageType == ContractInsurableObjectImageType.USER) {

      this.insurableObjectService.getObjectImage(this.insurableObject.imageUserId).subscribe(img => {
        this.addBase64Image(img);
      });

    } else if (this.insurableObject?.objectType == ContractInsurableObjectType.PERSON &&
      this.insurableObject?.imageType == ContractInsurableObjectImageType.USER) {

      this.insurableObjectService.getPersonImage(this.insurableObject.imageUserId).subscribe(img => {
        this.addBase64Image(img);
      });

    } else if (this.insurableObject?.objectType == ContractInsurableObjectType.PERSON &&
      this.insurableObject?.imageType == ContractInsurableObjectImageType.URL) {
      this.applyImage(this.insurableObject.imageUrl);

    } else if (this.insurableObject?.objectType == ContractInsurableObjectType.ME) {

      this.userService.getPhotoBase64().subscribe(value => {
        this.addBase64Image(value);
      }, error => {
        this.applyImage('assets/images/blank_user.png');
        // this.applyImage('assets/images/blank_insurable_object.png');
      });
    }


  }

  private addBase64Image(image: ImageDto) {
    this.applyImage(`data:${image.mimeType}};base64,${image.dataBase64}`);
  }

  private applyImage(imageSrc: string): void {
    this.el.nativeElement.src = imageSrc;
  }
}

